import { Box } from "@mui/system";
import React from "react";
import Nodata from "../../assets/img/noData.png";
import { Typography } from "@mui/material";

const NoDataComponent = () => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-evenly"}
      alignItems={"center"}
      py={5}
    >
      <img
        src={Nodata}
        alt=""
        //  srcset=""
      />
      <Typography variant="caption" gutterBottom style={{ marginY: "20px" }}>
        <b>No Data</b>
      </Typography>
    </Box>
  );
};

export default NoDataComponent;
